import {getMarketingErrorMessage, CUSTOM_PLAN_CODE} from 'shells/billing/add-ons/helpers';
import type {Cycle, AddOns, AddOn, SelectedAddOn} from 'shells/billing/types';

import type {GetAccountBilling_accountBilling_currentPlan as CurrentPlan} from 'nutshell-graphql-types';

import {getEngagementErrorText, getErrorText} from './manage/suite-header/helpers';

export const DEFAULT_CYCLE = 'MONTHLY';

export function getCycleFromPlanCode(planCode: string): Cycle {
    const planCodeComponents = planCode.split('-');
    if (planCodeComponents.length < 3) {
        return DEFAULT_CYCLE;
    }

    if (planCodeComponents[2] === 'a') {
        return 'ANNUALLY';
    }

    return DEFAULT_CYCLE;
}

export function shouldDisablePlanViewButton(
    numEnabledUsers: number,
    numUsers: string | null | undefined,
    isTrial: boolean,
    numMarketingOnlyUsers?: number | null
) {
    if (!numUsers) {
        return true;
    }

    if (numUsers === '0') {
        return true;
    }

    const errorText = getErrorText(numEnabledUsers, numUsers, isTrial, numMarketingOnlyUsers);

    return Boolean(errorText);
}

export function shouldDisableAddOnViewButton(
    addOns?: AddOns | null,
    selectedAddOns?: SelectedAddOn[] | null
): boolean {
    if (!addOns || !selectedAddOns) {
        return false;
    }

    const selectedMarketingAddOn = selectedAddOns.find((addOn) => addOn.product === 'MARKETING');

    const marketingErrorMessage = getMarketingErrorMessage(
        addOns.marketing.plans,
        selectedMarketingAddOn && selectedMarketingAddOn.planCode,
        addOns.marketing.numMarketingContacts,
        addOns.marketing.numMarketingContactsAllowedOverride
    );

    const isCustomPlanSelected = selectedAddOns.some(
        (addOn) => addOn.planCode === CUSTOM_PLAN_CODE
    );

    return Boolean(marketingErrorMessage || isCustomPlanSelected);
}

export function shouldDisableEngagementViewButton(
    numEnabledLicenses?: number | null,
    numUsers?: string | null
): boolean {
    const errorText = getEngagementErrorText(numEnabledLicenses, numUsers || '');

    return Boolean(errorText);
}

export function getAddOnsNotIncludedInPlan(
    addOns?: AddOns | null,
    currentPlan?: CurrentPlan | null
): AddOn[] {
    if (!addOns || !currentPlan) {
        return [];
    }

    let addOnsNotIncludedInPlan = [];
    for (const [addOnName, addOn] of Object.entries(addOns)) {
        // @ts-expect-error
        if (!currentPlan[addOnName]) {
            addOnsNotIncludedInPlan.push(addOn);
        }
    }

    // Filter out any add-ons that have no plans, as these are not real add-ons
    // to be displayed
    addOnsNotIncludedInPlan = (addOnsNotIncludedInPlan as Array<AddOn>).filter(
        (addOn) => addOn.plans.length > 0
    );

    return addOnsNotIncludedInPlan;
}
